import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../styles/mapStyles/SearchByGps.css";

// ─────────────────────────────────────────────
// SearchByGps
// Allows the user to enter latitude and longitude
// and trigger a search. Uses the same styling
// approach as SearchByLocation.
//
// Props:
// - onSearch: function that receives {lat, lng}
// - isLoading: disables the inputs while a search is in progress
// ─────────────────────────────────────────────

function SearchByGps({ onSearch, isLoading }) {
  const { t } = useTranslation();
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");

  // This runs when the user presses Enter on the keyboard or taps the Search button.
  const handleSubmit = (e) => {
    // Prevent the browser's default form behavior so we stay in our React flow.
    e?.preventDefault();

    // Convert the input strings to numbers
    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);

    // Validate that the inputs are valid numbers
    if (Number.isNaN(latitude) || Number.isNaN(longitude)) return;

    // Trigger the search
    onSearch({ lat: latitude, lng: longitude });
  };

  return (
    <form className="search-bar-wrapper search-by-gps" onSubmit={handleSubmit}>
      <div className="search-bar-input-row">
        {/* Because these inputs sit inside a form,
            pressing Enter on desktop or phone can submit the GPS search. */}
        <input
          type="number"
          className="search-bar-input gps-input"
          placeholder={t("search.latitude")}
          value={lat}
          onChange={(e) => setLat(e.target.value)}
          enterKeyHint="next"
          disabled={isLoading}
          step="any"
        />

        <input
          type="number"
          className="search-bar-input gps-input"
          placeholder={t("search.longitude")}
          value={lng}
          onChange={(e) => setLng(e.target.value)}
          enterKeyHint="search"
          disabled={isLoading}
          step="any"
        />

        <button
          type="submit"
          className="search-bar-btn"
          disabled={isLoading || !lat.trim() || !lng.trim()}
        >
          {isLoading ? t("common.searching") : t("common.search")}
        </button>
      </div>
    </form>
  );
}

export default SearchByGps;
